import {AxiosError} from 'axios';
import {POST_NON_NATIONAL_SEARCH_URL} from '../../constants/apiUrls';
import {NonNationalResultReleasesSchema} from '../../models/@org-admin/ResultReleasesShema';
import {ElasticSearchPaginationSchema} from '../../models/ElasticSearchPaginationSchema';
import {PaginatedData} from '../../models/List';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

export interface PostNonNationalSearchResultResponse extends ElasticSearchPaginationSchema {
  content: NonNationalResultReleasesSchema[];
}

export interface PostNonNationalSearchResultRequest {
  page: number;
  size: number;
  keywords: string | number;
}

interface Input {
  onSuccess?: (response: PaginatedData<PostNonNationalSearchResultResponse>) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostNonNationalSearchResultRelease = ({onSuccess, onError}: Input = {}) => {
  const PostNonNationalSearchResultRelease = async (
      reqBody: PostNonNationalSearchResultRequest
  ) => {
    const res = await axiosClient.post<PaginatedData<PostNonNationalSearchResultResponse>>(
        POST_NON_NATIONAL_SEARCH_URL(reqBody),
        {
          q: reqBody.keywords,
        }
    );

    return res.data;
  };

  return useCustomMutation(PostNonNationalSearchResultRelease, {
    onSuccess,
    onError,
  });
};
